import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { addDays, convertDateToCustomFormat } from '../../../../util/date-util';
import moment from 'moment';
import { TYPE_CHANGE_PLAN } from '@/constants';
import { getSpecificRoleUser } from '@/util/paid-user-util';

@Component({
  computed: {
    TYPE_CHANGE_PLAN() {
      return TYPE_CHANGE_PLAN;
    },
    moment() {
      return moment;
    },
    getMapTypeChangePlanAndMessage1(): Record<string, string> {
      return {
        UPGRADE: this.$t('payment.plan.confirm.upgradeMessage1', {
          currentPlanTitle: this.currentPlanTitle,
          nextPlanTitle: this.nextPlanTitle,
        }),
        DOWNGRADE: this.$t('payment.plan.confirm.downgradeMessage1', {
          currentPlanTitle: this.currentPlanTitle,
          nextPlanTitle: this.nextPlanTitle,
        }),
        CANCEL: this.$t('payment.plan.confirm.cancelMessage1', {
          currentPlanTitle: this.currentPlanTitle,
        }),
      };
    },
  },
  methods: { getSpecificRoleUser, addDays, convertDateToCustomFormat },
})
export default class ConfirmChangePlan extends Vue {
  @Prop(Boolean) readonly openModal;
  @Prop(String) readonly typeChangePlan;
  @Prop(String) readonly currentPlanTitle;
  @Prop(String) readonly nextPlanTitle;
  @Prop(String) readonly date;
  @Prop(String) readonly creditAmount;
  @Prop(Boolean) readonly waitingChangePlanApi;

  @Emit('close') close() {}
  @Emit('yes') yes() {}
}
